import styled from "styled-components";

export const Styles = styled.div`
  .mission-page {
    .mission-section {
      padding: 80px 0;
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      
      @media (max-width: 768px) {
        padding: 40px 0;
      }
    }

    .mission-content {
      background: #ffffff;
      border-radius: 20px;
      padding: 60px 40px;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 5px;
        background: linear-gradient(90deg, #4A90E2, #28A745, #FF6B35, #FFD700);
      }

      @media (max-width: 768px) {
        padding: 40px 20px;
        border-radius: 15px;
      }
    }

    .mission-header {
      text-align: center;
      margin-bottom: 40px;
      
      .mission-icon {
        margin-bottom: 20px;
        
        svg {
          filter: drop-shadow(0 4px 8px rgba(74, 144, 226, 0.3));
        }
      }

      .mission-title {
        font-size: 3rem;
        font-weight: 700;
        color: #2c3e50;
        margin: 0;
        position: relative;
        display: inline-block;

        &::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #4A90E2, #28A745);
          border-radius: 2px;
        }

        @media (max-width: 768px) {
          font-size: 2.2rem;
        }
      }
    }

    .mission-text {
      margin-bottom: 50px;
      
      p {
        font-size: 1.2rem;
        line-height: 1.8;
        color: #555;
        text-align: justify;
        margin: 0;
        font-weight: 400;

        @media (max-width: 768px) {
          font-size: 1.1rem;
          text-align: left;
        }
      }
    }

    .mission-highlights {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      gap: 30px;
      margin-top: 40px;

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 20px;
      }
    }

    .highlight-item {
      display: flex;
      align-items: flex-start;
      padding: 25px;
      background: #f8f9fa;
      border-radius: 15px;
      border-left: 5px solid #4A90E2;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
        background: #ffffff;
      }

      &:nth-child(2) {
        border-left-color: #28A745;
      }

      &:nth-child(3) {
        border-left-color: #FF6B35;
      }

      @media (max-width: 768px) {
        padding: 20px;
        flex-direction: column;
        text-align: center;
      }
    }

    .highlight-icon {
      margin-right: 20px;
      flex-shrink: 0;

      svg {
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
      }

      @media (max-width: 768px) {
        margin-right: 0;
        margin-bottom: 15px;
      }
    }

    .highlight-content {
      h4 {
        font-size: 1.3rem;
        font-weight: 600;
        color: #2c3e50;
        margin-bottom: 10px;
        margin-top: 0;
      }

      p {
        font-size: 1rem;
        color: #666;
        margin: 0;
        line-height: 1.6;
      }
    }

    /* Responsive adjustments */
    @media (max-width: 1200px) {
      .mission-highlights {
        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
      }
    }

    @media (max-width: 576px) {
      .mission-content {
        margin: 0 10px;
      }
      
      .mission-highlights {
        grid-template-columns: 1fr;
        gap: 15px;
      }
      
      .highlight-item {
        padding: 15px;
      }
    }
  }
`;